var _defs, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAnalytics = function SvgAnalytics(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".analytics_svg__a{fill:none;stroke:currentColor;stroke-linecap:round;stroke-linejoin:round}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.5 10a.5.5 0 0 0 .5.5h9.5a10 10 0 0 0-10-10ZM20.575 19.571A9.97 9.97 0 0 0 23.5 12.5H14c-.275 0-.341.159-.147.353Z",
    className: "analytics_svg__a"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5 3.5a10 10 0 1 0 7.071 17.071l-6.718-6.718A1.4 1.4 0 0 1 10.5 13Z",
    className: "analytics_svg__a"
  })));
};
export default SvgAnalytics;